import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Математика. 2-3 класс",
        subject: "Предупреждение трудностей в развитии  у обучающихся геометрических представлений на уроках математики во 2-3 классе",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Методические особенности формирования пропедевтических представлений о вероятности  и статистике",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Рыдзе Оксана Анатольевна",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории начального общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p style="padding-bottom: 1rem;">Исследование уровня математической подготовки выпускников начальной школы, которое проводит Институт стратегии развития образования в последние годы, показало, что школьники имеют трудности в различении, характеристике, представлении (рисование, черчение) изученных геометрических объектов, их отношений, нахождении величин. </p>
                                <p style="padding-bottom: 1rem;">В начальной школе решить проблему может помочь специальная работа над заданиями с геометрическим содержанием. Первым этапом этой работы должна стать характеристика учеником геометрической фигуры или фигур, представленных в задании. </p>
                                <p style="padding-bottom: 1rem;">В ходе характеристики (описания) фигур школьник будет закреплять умение пользоваться терминологией, различать геометрические объекты (фигуры, величины), выделять или сравнивать элементы. </p>
                                <p>Это позволит ученику лучше понять и удержать учебную задачу, поможет включиться в поиск решения, избежать типичных ошибок. Такую работу целесообразно начать уже во втором классе.</p>
                                    </div>`
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль. Часть 1",
            htmlPath: "./interactive/dist1/index.html",
            autoHeight: false
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 1",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video1.mp4"
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль. Часть 2",
            htmlPath: "./interactive/dist2/index.html",
            autoHeight: false
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 2",
            imagePath: "",
            id: "2",
            videoUrl: "./video/video2.mp4"
        },
        {
            order: 6,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1013",
            title: "Практический модуль. Часть 3",
            htmlPath: "./interactive/dist3/index.html",
            autoHeight: false
        },
        {
            order: 7,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Виноградова Н.Ф., Рыдзе О.А. Дидактическое сопровождение процесса обучения в начальной школе: формирование познавательных универсальных учебных действий: методическое пособие / под ред. Н.Ф. Виноградовой. – Москва: Просвещение. Учебная литература, 2018",
                "Федеральный государственный образовательный стандарт начального общего образования, утверждён Приказом Министерства просвещения Российской Федерации от 31 мая 2021 г. № 286",
                "Федеральная образовательная программа начального общего образования, утверждена Приказом Министерства просвещения России от 16.11.2022 N 992, зарегистрировано в Минюсте России 22.12.2022 N 71762",
                "Федеральная рабочая программа начального общего образования предмета «Математика»",
                "Математика. 1 класс. Учебник в 2-х частях. Ч. 2. Учебник для общеобразовательных организаций. – Москва: Просвещение, 2022",
            ],
            filesToDownload: [
                {
                    link: "./files/additional.pdf",
                    fileName: "Дополнительные задания, которые помогают реализовать потенциал анализа состава слов в обогащении словарного запаса"
                }
            ]
        }
    ],
};
